module.exports = __webpack_public_path__ + "img/ccurl_artsandsocial_logo.22b2b4c6.svg";